<template>
  <div>
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="text-center" style="margin-bottom: 5px; margin-top: -3px">
            <h3 class="text-white">
              RixPLS
            </h3>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center col-md-4 ml-auto mr-auto" style="margin-top: 35px">
      <h4 class="text-white">You have successfully verified your email</h4>
      <n-button @click.native="handleSubmit" native-type="submit" type="primary" round block>
        Ok
      </n-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmailVerified.vue",

  methods: {
    handleSubmit()
    {
      window.location = '/dashboard';
    },
  }
  }
</script>

<style scoped>

</style>